// @ts-nocheck
import PropTypes from "prop-types";
import {transformFiguresToAnimalData} from "../../../../../utils/lotteryDataTransformers";
import {
  animalButtonH176Cls,
  animalGridCls,
  animalIconCls,
  animalNumberCls,
  animalRowC5Cls,
  betChipAmountCls,
  betChipCls,
  betChipDeletionModeCls,
  bottomLeftCls,
  bottomRightCls,
  colorClsMap,
  gridContainerCls,
  special1Cls,
  special2Cls,
  specialButtonBaseCls,
  specialNumberCls,
  specialRedMiddleCls,
  topSectionH200C3Cls,
} from "../_numberGridShared";

const NumberGrid = ({
  onNumberClick,
  placedBets = [],
  maxBetPerOption = 1000,
  onMaxBetReached,
  isDeletionMode = false,
  figures = [],
}) => {
  const getAnimalData = () => {
    if (figures && figures.length > 0) {
      const transformed = transformFiguresToAnimalData(figures);
      return transformed;
    }
    const animals = [
      {number: 0, name: "delfin", color: "green", displayName: "Delfín"},
      {number: 75, name: "guacharo", color: "red", displayName: "Guácharo"},
      {number: "00", name: "ballena", color: "green", displayName: "Ballena"},
    ];

    for (let i = 1; i <= 74; i++) {
      animals.push({
        number: i,
        name: `animal${i}`,
        color: i % 2 === 1 ? "red" : "dark",
        displayName: `Animal ${i}`,
      });
    }

    return animals;
  };

  const animalData = getAnimalData();

  const specialNumbers = animalData.filter(animal => {
    const num = animal.number;
    return (
      num === "00" ||
      num === 0 ||
      num === "0" ||
      num === 75 ||
      num === "75" ||
      String(num) === "00" ||
      String(num) === "0" ||
      String(num) === "75"
    );
  });

  specialNumbers.sort((a, b) => {
    const order = {0: 0, 75: 1, "00": 2};
    const aValue = order[a.number];
    const bValue = order[b.number];
    return aValue - bValue;
  });

  const regularNumbers = animalData.filter(animal => {
    const num = animal.number;
    return !(
      num === "00" ||
      num === 0 ||
      num === "0" ||
      num === 75 ||
      num === "75" ||
      String(num) === "00" ||
      String(num) === "0" ||
      String(num) === "75"
    );
  });

  const createGridLayout = () => {
    const grid = [];
    const rows = Math.ceil(regularNumbers.length / 5);

    for (let row = 0; row < rows; row++) {
      const currentRow = [];
      for (let col = 0; col < 5; col++) {
        const index = row * 5 + col;
        if (index < regularNumbers.length) {
          currentRow.push(regularNumbers[index]);
        }
      }
      grid.push(currentRow);
    }
    return grid;
  };

  const gridLayout = createGridLayout();

  const getFichasForAnimal = animalId => {
    const animalBet = placedBets.find(bet => bet.animalId === animalId);
    return animalBet ? animalBet.fichas : [];
  };

  const getTotalBetForAnimal = animalId => {
    const fichas = getFichasForAnimal(animalId);
    return fichas.reduce((sum, ficha) => sum + ficha.value, 0);
  };

  const renderBetChip = animalId => {
    const fichas = getFichasForAnimal(animalId);
    if (fichas.length === 0) return null;

    const totalBet = getTotalBetForAnimal(animalId);

    return (
      <div
        className={`${betChipCls} ${isDeletionMode ? betChipDeletionModeCls : ""}`}
        title={isDeletionMode ? `Click para eliminar ($${totalBet})` : `Total apostado: ${totalBet}`}
      >
        <div className={betChipAmountCls}>{totalBet}</div>
      </div>
    );
  };

  const handleAnimalClick = animal => {
    const animalId = animal.number === "00" || animal.number === "0" ? animal.number : animal.number;

    if (isDeletionMode) {
      if (onNumberClick) {
        onNumberClick({
          betType: "animal",
          value: animal.number,
          name: animal.name,
          odds: "75:1",
        });
      }
      return;
    }

    const animalMaxBet = animal.maxBet || maxBetPerOption;

    const currentTotal = getTotalBetForAnimal(animalId);
    if (currentTotal >= animalMaxBet) {
      if (onMaxBetReached) {
        onMaxBetReached(animalId, animalMaxBet);
      }
      return;
    }

    if (onNumberClick) {
      onNumberClick({
        betType: "animal",
        value: animal.number,
        name: animal.name,
        odds: "75:1",
        maxBet: animalMaxBet,
      });
    }
  };

  return (
    <div className={gridContainerCls}>
      <div className={topSectionH200C3Cls}>
        {specialNumbers.map((animal, index) => {
          const imageUrl = animal.imageUrl || `/src/assets/images/lottery-icons/${animal.name}.svg`;
          const specialClass = index === 0 ? special1Cls : index === 1 ? specialRedMiddleCls : special2Cls;

          return (
            <button
              key={animal.number}
              type="button"
              className={`${specialButtonBaseCls} ${specialClass}`}
              onClick={() => handleAnimalClick(animal)}
            >
              <span className={specialNumberCls}>{animal.number}</span>
              <img
                src={imageUrl}
                alt={animal.displayName}
                className={animalIconCls}
                loading="eager"
                onError={e => {
                  e.target.src = `/src/assets/images/lottery-icons/${animal.name}.svg`;
                }}
              />
              {renderBetChip(animal.number)}
            </button>
          );
        })}

        {specialNumbers.length === 0 && (
          <>
            <button
              type="button"
              className={`${specialButtonBaseCls} ${special1Cls}`}
              onClick={() => handleAnimalClick({number: 0, name: "delfin", maxBet: maxBetPerOption})}
            >
              <span className={specialNumberCls}>0</span>
              <img
                src="/src/assets/images/lottery-icons/delfin.svg"
                alt="Delfín"
                className={animalIconCls}
                loading="eager"
              />
              {renderBetChip(0)}
            </button>

            <button
              type="button"
              className={`${specialButtonBaseCls} ${specialRedMiddleCls}`}
              onClick={() => handleAnimalClick({number: 75, name: "guacharo", maxBet: maxBetPerOption})}
            >
              <span className={specialNumberCls}>75</span>
              <img
                src="/src/assets/images/lottery-icons/guacharo.svg"
                alt="Guácharo"
                className={animalIconCls}
                loading="eager"
              />
              {renderBetChip(75)}
            </button>

            <button
              type="button"
              className={`${specialButtonBaseCls} ${special2Cls}`}
              onClick={() => handleAnimalClick({number: "00", name: "ballena", maxBet: maxBetPerOption})}
            >
              <span className={specialNumberCls}>00</span>
              <img
                src="/src/assets/images/lottery-icons/ballena.svg"
                alt="Ballena"
                className={animalIconCls}
                loading="eager"
              />
              {renderBetChip("00")}
            </button>
          </>
        )}
      </div>

      <div className={animalGridCls}>
        {gridLayout.map((row, rowIndex) => (
          <div
            key={`row-${row[0]?.number || `empty-${rowIndex}`}`}
            className={animalRowC5Cls}
          >
            {row.map(animal => (
              <button
                key={animal.number}
                type="button"
                className={`${animalButtonH176Cls} ${colorClsMap[animal.color]} ${animal.name === "animal70" ? bottomLeftCls : animal.name === "animal74" ? bottomRightCls : ""}`}
                onClick={() => handleAnimalClick(animal)}
              >
                <span className={animalNumberCls}>{animal.number.toString().padStart(2, "0")}</span>
                <img
                  src={animal.imageUrl || `/src/assets/images/lottery-icons/${animal.name}.svg`}
                  alt={animal.displayName || animal.name}
                  className={animalIconCls}
                  loading="eager"
                  onError={e => {
                    e.target.src = `/src/assets/images/lottery-icons/${animal.name}.svg`;
                  }}
                />
                {renderBetChip(animal.number)}
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

NumberGrid.propTypes = {
  gameIdString: PropTypes.string.isRequired,
  onNumberClick: PropTypes.func,
  placedBets: PropTypes.arrayOf(
    PropTypes.shape({
      animalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      animalName: PropTypes.string,
      fichas: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.number,
          name: PropTypes.string,
        })
      ),
    })
  ),
  maxBetPerOption: PropTypes.number,
  onMaxBetReached: PropTypes.func,
  isDeletionMode: PropTypes.bool,
  figures: PropTypes.arrayOf(PropTypes.object),
};

export default NumberGrid;
